import React from 'react';
import { Result, Spin } from 'antd';
import { useAuth } from '../../context/AuthContext';
import ReportsManager from '../../components/hr/ReportsManager';
import { useHRReportScope } from '../../components/hr/hrReportsApi';

const ReportsWrapper: React.FC = () => {
  const { user } = useAuth();
  const scope = useHRReportScope();
  if (!user) return <Spin style={{ display: 'block', padding: 48 }} tip="Vérification des permissions…" />;
  if (!scope.allowed) return <Result status="403" title="Accès aux rapports RH non autorisé" />;
  if (!scope.companyId) return <Result status="info" title="Sélectionnez une entreprise" subTitle="Choisissez l’entreprise dont vous souhaitez consulter les rapports RH." />;
  return <ReportsManager key={`${scope.userId}:${scope.companyId}:${scope.warehouseId || ''}`} />;
};

export default ReportsWrapper;
